import { logError } from '@savgroup-front-common/configuration/appInsights/AppInsights';

export interface AdyenSession {
  id: string;
  sessionData: string;
}

export const adaptPaymentIntentToAdyenSession = ({
  paymentIntent,
}: {
  paymentIntent?: string;
}): AdyenSession | undefined => {
  if (!paymentIntent) {
    return undefined;
  }

  try {
    const { id, sessionData } = JSON.parse(
      paymentIntent,
    ) as Partial<AdyenSession>;

    if (!id || !sessionData) {
      logError('adaptPaymentIntentToAdyenSession: missing id or sessionData', {
        hasId: Boolean(id),
        hasSessionData: Boolean(sessionData),
      });

      return undefined;
    }

    return { id, sessionData };
  } catch (error) {
    logError(error, {
      origin: 'adaptPaymentIntentToAdyenSession',
      message: 'Unable to parse the payment intent returned by the backend',
    });

    return undefined;
  }
};
